import React, { Component } from "react";
import { Route, Routes } from 'react-router-dom';
//scss part
import './components/assets/base.scss';
// @mui/icons-material
import  HomeOutlinedIcon  from "@mui/icons-material/HomeOutlined";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
// core components/views for Admin layout
import TeacherHome from "./views/Home/Teacherhome.jsx";
import StudentHome from "./views/Home/Studenthome.jsx";
import DashboardPage from "../src/views/Dashboard/Dashboard";
import StudentDashboard from "../src/views/Dashboard/StudentDashboard.jsx";
import UserProfile from "../src/views/UserProfile/UserProfile";
import Admin from './components/layouts/Admin.jsx';
import Student from './components/layouts/Student.jsx';
import Landing from "../src/components/layouts/Landing";
import ForgotPass from "./components/layouts/ForgotPass.jsx";
import LandingWrapper from "./LandingWrapper"; // use the wrapper version
//core components module for admin module
import Createmod from "./views/Home/Createmod.jsx";
import Editmod from "./views/Home/Editmod.jsx";
import ViewModule from "./views/Home/ViewModule.jsx";
//core components class for admin module
import CreateClass from '../src/views/Dashboard/CreateClass'
import ViewClass from '../src/views/Dashboard/ViewClass'
import EditClass from './views/Dashboard/EditClass.jsx'
//core components session for admin module
////KG creation components
import ProStatement from '../src/views/CreateKG/ProStatement'  
//import CreateSession from './views/Session/Sessionhome.jsx'
//import SessionLibrary from './views/Session/SessionLibrary.jsx'
import ViewSession from '../src/views/Session/ViewSession'
//import SessionQuery from './views/Session/SessionQuery.jsx';
//import ViewForum from './views/Session/ViewForum.jsx';
import GroupWork from '../src/views/Session/GroupWork.jsx'
import FinalAssessment from '../src/views/Session/FinalAssessment'
//core components class for student module in CT
import ViewStudentClass from './views/Dashboard/ViewStudentClass'
import Activity1Easy from '../src/views/StudentSession/Activity1Easy'
import Activity1 from '../src/views/StudentSession/Activity1'
import Activity1Hard from '../src/views/StudentSession/Activity1Hard'
import Activity2Easy from '../src/views/StudentSession/Activity2Easy'
import Activity2Medium from '../src/views/StudentSession/Activity2Medium'
import Activity2Hard from '../src/views/StudentSession/Activity2Hard'
import Activity3Easy from '../src/views/StudentSession/Activity3Easy'
import Activity3Medium from '../src/views/StudentSession/Activity3Medium'
import Activity3Hard from '../src/views/StudentSession/Activity3Hard'
import Activity4Easy from '../src/views/StudentSession/Activity4Easy'
import Activity4Medium from '../src/views/StudentSession/Activity4Medium'
import Activity4Hard from '../src/views/StudentSession/Activity4Hard'
import Activity5Easy from '../src/views/StudentSession/Activity5Easy'
import Activity5Medium from '../src/views/StudentSession/Activity5Medium'
import Activity5Hard from '../src/views/StudentSession/Activity5Hard'
import Activity6Easy from '../src/views/StudentSession/Activity6Easy'
import Activity6Medium from '../src/views/StudentSession/Activity6Medium'
import Activity6Hard from '../src/views/StudentSession/Activity6Hard'
import Activity7Easy from '../src/views/StudentSession/Activity7Easy'
import Scenario from '../src/views/StudentSession/Scenario'
import AnalyticsPage from '../src/views/StudentSession/AnalyticsPage'
import ActivityTest from '../src/views/StudentSession/ActivityTest'
import ActivityPostTest from './views/StudentSession/ActivityPostTest'
import FinalPage from '../src/views/StudentSession/FinalPage'
import ActivityList from '../src/views/StudentSession/activityList'
import TestQuestions from '../src/views/StudentSession/TestQuestions'

//core components from coding
//import Scratch from '../src/views/Dashboard/Scratch'
import Ide from '../src/views/Ide/Ide';
import IdeAct2 from '../src/views/Ide/ideActivity2';
import IdeAct3 from '../src/views/Ide/IdeActivity3';
import IdeAct4 from './views/Ide/IdeActivity4';
import IdeAct5 from '../src/views/Ide/IdeActivity5';

///json components for data
import { MODULES } from '../src/components/shared/modules.js';
import { CLASS } from '../src/components/shared/class.js';
import { SESSION_DETAILS } from '../src/components/shared/sessions.js'









class rout extends Component{
  constructor(props){
    super(props);

    this.state={
      modules: MODULES,
      classes: CLASS,
      session_details:SESSION_DETAILS,
      moduleList:'',
      loading:true,
      showModal:true
    };
    this.filterSess = this.filterSess.bind(this);



  }

 

  filterSess(clsId, sessId ){
    let classe; 
    this.state.classes.map((cls) => 
    {if(cls.id === parseInt(clsId, 10)){
      classe = cls.sessions.filter((cls) => cls.id === parseInt(sessId, 10))
    }
  });
    
  return(classe);
       
  } 
  


  render(){

    //console.log(this.state.moduleList) 

    const THome = () =>{
      return(
        <TeacherHome type="teacher" clas = {this.state.classes}/>
      );
    }

    const TDash = () =>{
      return(
        <DashboardPage type="teacher" />
      );
    }
    
    const TeacherProfile = () => {
      return(
        <UserProfile type="teacher"/>
      );
    }
    
    const StudentProfile = () => {
      return(
        <UserProfile type="student"/>
      );
    }

     const ProState = ({match}) =>{
      return(
      <ProStatement match={match} type="teacher" />
    );
    }


    const Adm = () => {
      return(
      <Admin routes = {dashboardRoutes} />  );
    }
    
    const Std = () => {
      return(
      <Student routes = {dashboardRoutes} />);
    }

   

    ///////////////////////Edit and View Module///////////////////////////////////
    const ModCreateMod = ({match}) =>{
      return(
          <Createmod match={match}                 
          />
          );
    }

    const ModWithId = ({match}) =>{
      return(
          <ViewModule match={match}                
          clas = {this.state.classes} />
          );
    }

    const EditModWithId = ({match}) =>{
      return(
          <Editmod match={match}                 
          />
          );
    }
/////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////Edit and View Class////////////////////////////////////////////////////////////

    const ClassWithId = ({match}) =>{
      return(
          <ViewClass match={match}
                          
          />
          );
    }

    const EditClassWithId = ({match}) =>{
      return(
          <EditClass match={match}
          />
          );
    }
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
const CreateSess = ({match}) => {
  return(
  <CreateSession  match={match} />);
};

const SessionLibraryHome = ({match}) => {
  return(
  <SessionLibrary  match={match} />);
};


const ViewSess = ({match}) => {
  return(
  <ViewSession match={match}  />);
}
const ViewGroupWork = ({match}) => {
  return(
  <GroupWork match={match}  />);
}

const ViewQuery = ({match}) => {
  return(
  <SessionQuery match={match}  />);
}

const ViewForumTeacher = ({match}) => {
  return(
  <ViewForum match={match}  />);
}

const StudentClassWithId = ({match}) =>{
  return(
      <ViewStudentClass match={match}
                      
      />
      );
}

const StudentActivity1EasyWithId = ({match}) =>{
  return(
      <Activity1Easy match={match}
                      
      />
      );
}

const StudentActivity1WithId = ({match}) =>{
  return(
      <Activity1 match={match}
                      
      />
      );
}

const StudentActivity1HardWithId = ({match}) =>{
  return(
      <Activity1Hard match={match}
                      
      />
      );
}

const StudentActivity2EasyWithId = ({match}) =>{
  return(
      <Activity2Easy match={match}
                      
      />
      );
}

const StudentActivity2MediumWithId = ({match}) =>{
  return(
      <Activity2Medium match={match}
                      
      />
      );
}

const StudentActivity2WithId = ({match}) =>{
  return(
      <Activity2Hard match={match}
                      
      />
      );
}

const StudentActivity3WithId = ({match}) =>{
  return(
      <Activity3Easy match={match}
                      
      />
      );
}
const StudentActivity3MediumWithId = ({match}) =>{
  return(
      <Activity3Medium match={match}
                      
      />
      );
}
const StudentActivity3HardWithId = ({match}) =>{
  return(
      <Activity3Hard match={match}
                      
      />
      );
}
const StudentActivity4WithId = ({match}) =>{
  return(
      <Activity4Easy match={match}
      />
      );
}
const StudentActivity4MediumWithId = ({match}) =>{
  return(
      <Activity4Medium match={match}
      />
      );
}
const StudentActivity4HardWithId = ({match}) =>{
  return(
      <Activity4Hard match={match} 
      />
      );
}
const StudentActivity5WithId = ({match}) =>{
  return(
      <Activity5Easy match={match} 
      />
      );
}

const StudentActivity5MediumWithId = ({match}) =>{
  return(
      <Activity5Medium match={match} 
      />
      );
}
const StudentActivity5HardWithId = ({match}) =>{
  return(
      <Activity5Hard match={match} 
      />
      );
}
const StudentActivity6WithId = ({match}) =>{
  return(
      <Activity6Easy match={match} 
      />
      );
}

const StudentActivity6MediumWithId = ({match}) =>{
  return(
      <Activity6Medium match={match} 
      />
      );
}
const StudentActivity6HardWithId = ({match}) =>{
  return(
      <Activity6Hard match={match} 
      />
      );
}
const StudentActivity7WithId = ({match}) =>{
  return(
      <Activity7Easy match={match} 
      />
      );
}
const StudentTestWithId = ({match}) =>{
  return(
      <ActivityTest match={match}
                      
      />
      );
}

const StudentPostTestWithId = ({match}) =>{
  return(
      <ActivityPostTest match={match}
                      
      />
      );
}

const StudentFinalPageId = ({match}) =>{
  return(
      <FinalPage match={match}
                      
      />
      );
}
const StudentActivityList = ({match}) =>{
  return(
      <ActivityList match={match}
                      
      />
      );
}


const StudentTestQuestions = ({match}) =>{
  return(
      <TestQuestions match={match}
                      
      />
      );
}
const StudentBoardWithId = ({match}) =>{
  return(
      <Board match={match}
                      
      />
      );
}   

const StudentForumWithId = ({match}) =>{
  return(
      <Forum match={match}
                      
      />
      );
}

const StudentReportWithId = ({match}) =>{
  return(
      <ReportWriting match={match}
                      
      />
      );
}

const StudentPeerWithId = ({match}) =>{
  return(
      <PeerReview match={match}
                      
      />
      );
}

const StudentReviseWithId = ({match}) =>{
  // return(
  //     <ReviseReport match={match}
                      
  //     />
  //     );
    return;

}

const Coding = ({match}) =>{
  // return(
  //     <Scratch match={match} />
  //   );
  return;
}

const MyCode = ({match}) =>{
  return(
      <Ide match={match} />
    );
}

const MyCode2 = ({match}) =>{
  return(
      <IdeAct2 match={match} />
    );
}

const MyCode3 = ({match}) =>{
  return(
      <IdeAct3 match={match} />
    );
}

const MyCode4 = ({match}) =>{
  return(
      <IdeAct4 match={match} />
    );
}

const MyCode5 = ({match}) =>{
  return(
      <IdeAct5 match={match} />
    );
}
const MyScenario = ({match}) =>{
  return(
      <Scenario match={match} />
    );
}
const MyAnalytics = ({match}) =>{
  return(
      <AnalyticsPage match={match} />
    );
}



    const dashboardRoutes = [
    
      {
        path: "/home",
        name: "Home",
        icon: HomeOutlinedIcon,
        component: THome,
        layout: "/admin"
      },
      {
        path: "/home",
        name: "Home",
        icon: HomeOutlinedIcon,
        component: StudentHome,
        layout: "/student"
    
      },
      
      {
        path: "/dashboard",
        name: "Dashboard",
        icon: DashboardIcon,
        component: TDash,
        layout: "/admin"
      },
    
      {
        path: "/dashboard",
        name: "Dashboard",
        icon: DashboardIcon,
        component: StudentDashboard,
        layout: "/student"
      },
      {
        path: "/user",
        name: "My Profile",
        icon: PersonIcon,
        component: TeacherProfile,
        layout: "/admin"
      },
      {
        path: "/user",
        name: "My Profile",
        icon: PersonIcon,
        component: StudentProfile,
        layout: "/student"
      },
      {
        path: "/home/createmodule/:classId?",
        name: "Create Module",
        icon: "None",
        component: ModCreateMod,
        layout: "/admin"
      },
      {
        path: "/createkg/:kgId?",
        name: "Create KG",
        icon: "None",
        component: ProState,
        layout: "/admin"
      },
      {
        path: "/home/viewmodule/:modId/:classId?",
        name: "View Module",
        icon: "None",
        component: ModWithId,
        layout: "/admin"
      },
      {
        path: "/home/editmodule/:modId/:classId?",
        name: "Edit Module",
        icon: "None",
        component: EditModWithId,
        layout: "/admin"
      },
      {
        path: "/dashboard/createclass/:modId?",
        name: "Create Class",
        icon: "None",
        component: CreateClass,
        layout: "/admin"
      },
      {
        path: "/dashboard/viewclass/:classId",
        name: "View Class",
        icon: "None",
        component: ClassWithId,
        layout: "/admin"
      },
      {
        path: "/dashboard/editclass/:classId",
        name: "Edit Class",
        icon: "None",
        component: EditClassWithId,
        layout: "/admin"
      },
      {
        path: "/dashboard/viewclass/:classId/viewquery/:sesId/:profileId/:userId/",
        name: "View Query",
        icon: "None",
        component: ViewQuery,
        layout: "/admin"
      },
      {
        path: "/dashboard/createsession/:classId?/:modId?",
        name: "Create Session",
        icon: "None",
        component: CreateSess,
        layout: "/admin"
      },
      {
        path: "/dashboard/modulelibrary/:classId?/:modId?",
        name: "Create Session",
        icon: "None",
        component: SessionLibraryHome,
        layout: "/admin"
      }
      ,
      {
        path: "/dashboard/viewclass/:classId/viewsession/:sesId",
        name: "View Session",
        icon: "None",
        component: ViewSess,
        layout: "/admin"
      },
      {
        path: "/dashboard/viewclass/:classId/viewforum/:sesId/:grplstId",
        name: "View Forum",
        icon: "None",
        component: ViewForumTeacher,
        layout: "/admin"
      },
      {
        path: "/dashboard/viewclass/viewsession/:classId/:sesId/work/:userId/:id",
        name: "Group work",
        icon: "None",
        component: ViewGroupWork,
        layout: "/admin"
      },
      {
        path: "/dashboard/viewclass/:classId/viewsession/:sesId/:grplstId/finalassess",
        name: "Final Assessment",
        icon: "None",
        component: FinalAssessment,
        layout: "/admin"
      },
      {
        path: "/dashboard/viewsession/:classId",
        name: "View Student Class",
        icon: "None",
        component: StudentClassWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity1easy",
        name: "First Activity",
        icon: "None",
        component: StudentActivity1EasyWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity1medium",
        name: "First Activity",
        icon: "None",
        component: StudentActivity1WithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity1hard",
        name: "First Activity",
        icon: "None",
        component: StudentActivity1HardWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/:classId/session/:sesId/mycode/",
        name: "Coding",
        icon: "None",
        component: MyCode,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity2easy",
        name: "Second Activity",
        icon: "None",
        component: StudentActivity2EasyWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity2medium",
        name: "Second Activity",
        icon: "None",
        component: StudentActivity2MediumWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity2hard",
        name: "Second Activity",
        icon: "None",
        component: StudentActivity2WithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/mycode2/",
        name: "Coding",
        icon: "None",
        component: MyCode2,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity3easy",
        name: "Third Activity",
        icon: "None",
        component: StudentActivity3WithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity3medium",
        name: "Third Activity",
        icon: "None",
        component: StudentActivity3MediumWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity3hard",
        name: "Third Activity",
        icon: "None",
        component: StudentActivity3HardWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/mycode3/",
        name: "Coding",
        icon: "None",
        component: MyCode3,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity4easy",
        name: "Fourth Activity",
        icon: "None",
        component: StudentActivity4WithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity4medium",
        name: "Fourth Activity",
        icon: "None",
        component: StudentActivity4MediumWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity4hard",
        name: "Fourth Activity",
        icon: "None",
        component: StudentActivity4HardWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/mycode4/",
        name: "Coding",
        icon: "None",
        component: MyCode4,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity5easy",
        name: "Fifth Activity",
        icon: "None",
        component: StudentActivity5WithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity5medium",
        name: "Fifth Activity",
        icon: "None",
        component: StudentActivity5MediumWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity5hard",
        name: "Fifth Activity",
        icon: "None",
        component: StudentActivity5HardWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity6easy",
        name: "Sixth Activity",
        icon: "None",
        component: StudentActivity6WithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity6medium",
        name: "Sixth Activity",
        icon: "None",
        component: StudentActivity6MediumWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activity6hard",
        name: "Sixth Activity",
        icon: "None",
        component: StudentActivity6HardWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activitydemo",
        name: "Sixth Activity",
        icon: "None",
        component: StudentActivity7WithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activitypretest",
        name: "Test",
        icon: "None",
        component: StudentTestWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activityposttest",
        name: "PostTest",
        icon: "None",
        component: StudentPostTestWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/activityfinal",
        name: "PostTest",
        icon: "None",
        component: StudentFinalPageId,
        layout: "/student"
      },
      {
        path: "/dashboard/studentactivitylist",
        name: "PostTest",
        icon: "None",
        component: StudentActivityList,
        layout: "/student"
      },
      {
        path: "/dashboard/studenttestquestions",
        name: "PostTest",
        icon: "None",
        component: StudentTestQuestions,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/mycode5/",
        name: "Coding",
        icon: "None",
        component: MyCode5,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/board",
        name: "Board section",
        icon: "None",
        component: StudentBoardWithId,
        layout: "/student"
      }
      ,
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/forum",
        name: "Forum section",
        icon: "None",
        component: StudentForumWithId,
        layout: "/student"
      }
      ,
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/report",
        name: "Report section",
        icon: "None",
        component: StudentReportWithId,
        layout: "/student"
      }
      ,
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/peer-review",
        name: "Peer review section",
        icon: "None",
        component: StudentPeerWithId,
        layout: "/student"
      }
      ,
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/revised-report",
        name: "Revised report section",
        icon: "None",
        component: StudentReviseWithId,
        layout: "/student"
      },
      {
        path: "/dashboard/coding/",
        name: "Coding",
        icon: "None",
        component: Coding,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/profile/:profileId/scenario",
        name: "Scenario",
        icon: "None",
        component: MyScenario,
        layout: "/student"
      },
      {
        path: "/dashboard/viewstudentclass/:classId/session/:sesId/analytics/:actId",
        name: "Analytics",
        icon: "None",
        component: MyAnalytics,
        layout: "/student"
      }
      
    ];


    


    return( 
   
      <Routes>
    
        <Route path="/admin/*" element={<Adm />} />
        <Route path="/student/*" element={<Std />} />
        <Route path="/" element={<LandingWrapper setShowModal={this.props.setShowModal} />} />
        <Route path="/forgotpassword" element={<ForgotPass />} />

      </Routes>
  
    );
  }
} 

export default rout;
